/**
 * Generated bundle index. Do not edit.
 */
export { MatInputModule, MatTextareaAutosize, MatInput, getMatInputUnsupportedTypeError } from './public-api';
//# sourceMappingURL=index.js.map